module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_1.body)
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/donate/1"
    }
  }, [_vm._v(_vm._s(_vm.content.section_1.button_text))])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.content.section_1.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.content.section_1.image
    }
  })]) : _vm._e()])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "featured-content-heading"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.section_2.body)
    }
  })])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "featured-donate-block"
  }, [_c('div', {
    staticClass: "featured-donate-block__number"
  }, [_vm._v("\n                1\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "featured-donate-block__content"
  }, [_c('sk-button', {
    attrs: {
      "link": "",
      "tag": "a",
      "href": "/donate/1"
    }
  }, [_c('p', [_c('strong', [_vm._v("Donate")]), _vm._v(" R100 or more online now")])])], 1)])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "featured-donate-block"
  }, [_c('div', {
    staticClass: "parent"
  }, [_c('div', {
    staticClass: "featured-donate-block__number"
  }, [_vm._v("\n                    2\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "featured-donate-block__content"
  }, [_c('p', [_vm._v("Donate R2.50 or more when you "), _c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("book a movie")]), _vm._v(" or using "), _c('strong', [_vm._v("Quick Book")])], 1)])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "featured-donate-block"
  }, [_c('div', {
    staticClass: "featured-donate-block__number"
  }, [_vm._v("\n                  3\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "featured-donate-block__content"
  }, [_c('p', [_vm._v("You can use the Self-Service terminals in our cinema foyers to donate. See "), _c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("what's on.")])], 1)])])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "featured-donate-button"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/donate/1"
    }
  }, [_vm._v(_vm._s(_vm.content.section_1.button_text))])], 1)])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "label": "Book and Donate",
      "movies": _vm.movies.now_showing
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4452b6ac","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vision-mission/how-it-works/how-it-works.vue
// module id = 847
// module chunks = 0